import { EmployerFooter, EmployerHeader } from '@seek/adv-header-footer';
import { useAccountContext } from '@seek/hirer-graphql-react';
import type { Locale } from '@seek/melways-sites';
import { Box, Page } from 'braid-design-system';
import type React from 'react';

import {
  trackLinkRenderer,
  TrackingOrigins,
} from 'src/App/components/TrackingLink/trackLinkRenderer';
import { useQueryParam } from 'src/hooks/useQueryParam';
import type { EmployerSiteName } from 'src/types';

interface HeaderAndFooterWrapperProps {
  locale: Locale;
  site: EmployerSiteName;
  isStaging: boolean;
}

export const HeaderAndFooterWrapper: React.FunctionComponent<
  React.PropsWithChildren<HeaderAndFooterWrapperProps>
> = ({ children, locale, site, isStaging }) => {
  const { accountContext } = useAccountContext();
  const { tab } = useQueryParam();

  return (
    <Page
      footer={
        <EmployerFooter
          id="employer-footer"
          locale={locale}
          site={site}
          isStaging={isStaging}
          linkRenderer={trackLinkRenderer(
            TrackingOrigins.TRACKING_ORIGIN_FOOTER,
          )}
          {...accountContext?.headerFooterContext}
        />
      }
    >
      <EmployerHeader
        id="employer-header"
        activeTabId="jobs"
        locale={locale}
        site={site}
        isStaging={isStaging}
        activeSubTabId={tab}
        linkRenderer={trackLinkRenderer(TrackingOrigins.TRACKING_ORIGIN_HEADER)}
        {...accountContext?.headerFooterContext}
      />
      <Box component="main">{children}</Box>
    </Page>
  );
};
